import { render, staticRenderFns } from "./AddEditWidget.vue?vue&type=template&id=4292152b&scoped=true"
import script from "./AddEditWidget.vue?vue&type=script&lang=js"
export * from "./AddEditWidget.vue?vue&type=script&lang=js"
import style0 from "./AddEditWidget.vue?vue&type=style&index=0&id=4292152b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292152b",
  null
  
)

export default component.exports